import $i18n from '@alife/panda-i18n';
export const getExtraLabel = (subTitle) => {
    switch (subTitle) {
        case 1:
            return $i18n.get({ id: 'TERM.GoalGoals', dm: '目标' });
        default:
            return undefined;
    }
};
